"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for forbidden responses on fetching school entities
 * @param {string} schoolId the school id
 */
class ForbiddenAccessToSchoolEntitiesError extends client_library_1.ExtendableError {
    constructor(schoolId) {
        super(`Forbidden access to externally managed school entities. ${schoolId}`);
        this.schoolId = schoolId;
    }
}
exports.default = ForbiddenAccessToSchoolEntitiesError;
//# sourceMappingURL=ForbiddenAccessToSchoolEntitiesError.js.map